import { ButtonBase } from '@material-ui/core';
import VinScanIcon from 'img/vin-scan.svg';
import { useRef } from 'react';
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { useUploadWithVinImageMutation } from 'services/api/upload-vehicle';
import { openVinDialog } from 'services/listerUploadVehicle/v2';
import { closeLoadingModal, openLoadingModal } from 'services/ui/uiSlice';
import { parseFile } from 'utils/file';

export const VinScanButton = () => {
  const inputRef = useRef<HTMLInputElement>(null);

  const openFileInput = () => inputRef.current?.click();

  const [uploadVehicle] = useUploadWithVinImageMutation();
  const dispatch = useDispatch();

  const handleFileChange: React.ChangeEventHandler<HTMLInputElement> = async event => {
    event.preventDefault();
    const file = event.target.files?.[0];
    if (!file) return;
    const parsedFile = await parseFile(file)
    dispatch(openLoadingModal());
    const response = await uploadVehicle(parsedFile);
    dispatch(closeLoadingModal());
    if ('data' in response) {
      dispatch(openVinDialog({ vehicleId: null, type: 'upload', vin: response.data }));
    } else {
      toast.error('Failed to recognize image');
    }
  };

  return (
    <>
      <input onChange={handleFileChange} ref={inputRef} type="file" name="loadVin" style={{ display: 'none' }} />
      <ButtonBase onClick={openFileInput}>
        <VinScanIcon />
      </ButtonBase>
    </>
  );
};
